import { getTranslation } from '@owc/aem-translations-util';
import { ComponentCategory, PHRASE_DCP, PHRASE_ONE_TEASER, Severity, locale, logError } from '@sccs/common';
import { initializeLogger } from '@seamless/logger';

export const enum TranslationType {
  DCP,
  ONE_TEASER,
}

let dcpTranslations: Record<string, string> = {};
let oneTeaserTranslations: Record<string, string> = {};

export function useI18n() {
  async function loadTranslations(logger?: ReturnType<typeof initializeLogger>): Promise<void> {
    const translationLocale = async (separator: string) => {
      let mappedLocale = await locale(separator);
      if (mappedLocale === `de${separator}AQ`) {
        mappedLocale = `de${separator}DE`;
      }
      if (mappedLocale === `en${separator}AQ`) {
        mappedLocale = `en${separator}AU`;
      }
      return mappedLocale;
    };
    try {
      dcpTranslations = await getTranslation(await translationLocale(PHRASE_DCP.separator), PHRASE_DCP.id, 'i18next');
    } catch (error) {
      logError(
        {
          error: error as Error,
          severity: Severity.CRITICAL,
          component: ComponentCategory.DATALOADING,
          message: `INFL_I18N_OT: Failed to fetch DCP translations for market ${await translationLocale(PHRASE_DCP.separator)}`,
        },
        logger,
      );
    }
    try {
      oneTeaserTranslations = await getTranslation(
        await translationLocale(PHRASE_ONE_TEASER.separator),
        PHRASE_ONE_TEASER.id,
        'i18next',
      );
    } catch (error) {
      logError(
        {
          error: error as Error,
          severity: Severity.CRITICAL,
          component: ComponentCategory.DATALOADING,
          message: `INFL_I18N_OT: Failed to fetch OneTeaser translations for market ${await translationLocale(PHRASE_ONE_TEASER.separator)}`,
        },
        logger,
      );
    }
  }

  function t(key: string, dataset: TranslationType = TranslationType.DCP): string {
    switch (dataset) {
      case TranslationType.ONE_TEASER:
        return getTranslationFromKey(key, oneTeaserTranslations) || key;
      case TranslationType.DCP:
      default:
        return getTranslationFromKey(key, dcpTranslations) || key;
    }
  }

  function getTranslationFromKey(key: string, translations: Record<string, string>): string | undefined {
    return key.split('.').reduce((objectPart: any, keyPart: string) => {
      if (objectPart) {
        return objectPart[keyPart];
      } else {
        return undefined;
      }
    }, translations);
  }

  return { loadTranslations, t };
}
